// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__2J-KL","Label":"Input_Label__3Qgm-","InputElement":"Input_InputElement__1Dfne","Invalid":"Input_Invalid__1G4gq"};